// Çerçeve düzeyi ayarların (FormManager) kopya tek kaynağı — period-ui.ts desenindeki gibi
// UI'da satır içi string yazılmaz.
export const FRAMEWORK_UI_COPY = {
  // "Bölüm kodları standart referansıdır" anahtarı (0062).
  standardRefsLabel: "Bölüm kodları standart referansıdır",
  standardRefsHelp:
    "Açıkken rapor bölümlerinin sonunda “İlgili standart” dipnotu basılır (marka ayarı da açıksa). GRI/TSRS gibi standart çerçeveler içindir; bölüm kodları iç koddan ibaretse (SPK/BDDK faaliyet raporu, özel çerçeve) kapalı bırakın.",
  standardRefsBadgeOff: "kapalı",
  standardRefsLockedTitle: "Bu çerçeveyi düzenleme yetkiniz yok",
} as const;
